<template>
  <el-col>
    <div class="all">
      <div class="downAnd" @click="downIos()" v-show="Num === 1 || Num === 3">
        <img src="../../../../assets/img/link/iOS.png" width="20px" height="20px" alt="" />
        <span>下载iPhone客户端</span>
      </div>
      <div class="downAnd" @click="downAnd()" v-show="Num === 2 || Num === 4">
        <img src="../../../../assets/img/link/android.png" width="20px" height="20px" alt="" />
        <span>下载Android客户端</span>
      </div>
    </div>
    <div class="imglist">
      <img
        v-for="(item, i) in imgList"
        :key="i"
        :src="item.url"
        width="25px"
        height="25px"
        alt=""
      />
      <div class="downurl">支持 iOS，Android，Windows，macOS系统</div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: 'andMobile',
  props: {
    classIsMobile: {
      type: Number
    },
    loadList: {
      type: Array
    }
  },
  data() {
    return {
      Num: 0,
      and: {},
      ios: {},
      list: [],
      imgList: [
        { url: require('@/assets/img/ios.png') },
        { url: require('@/assets/img/andriod.png') },
        { url: require('@/assets/img/window.png') },
        { url: require('@/assets/img/mac.png') }
      ]
    }
  },
  created() {
    this.Num = this.classIsMobile
  },
  watch: {
    loadList(value) {
      this.list = value
      this.list.map(item => {
        if (item.typeId === 1) {
          this.and = item
        } else if (item.typeId === 2) {
          this.ios = item
        }
      })
    }
  },
  methods: {
    downAnd() {
      this.$router.push({ path: '/mobileDownload' })
    },
    downIos() {
      window.location.href = this.ios.apkFileUrl
    }
  }
}
</script>

<style scoped lang="scss">
.el-col {
  margin-bottom: 20px;
  text-align: center;
}
.all {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .downAnd {
    width: 183px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    background: #2053cd;
    border-radius: 21px;
    font-size: 12px;
    color: #ffffff;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      vertical-align: text-bottom;
      margin-right: 10px;
    }
  }
}
.imglist {
  margin-top: 30px;
  img {
    margin: 0 10px;
  }
  .downurl {
    font-size: 12px;
    color: #4b5863;
    text-align: center;
    line-height: 17px;
    margin-top: 15px;
  }
}
</style>
